import React, { useState } from 'react';

import { Form, Input } from 'antd';

import { EyeClosed, EyeOpen } from '../../../assets/icons';

export const PasswordLoginField = (props) => {
  const { name, password, setPassword, autoCompletePassword } = props;

  const [passwordVisible, setPasswordVisible] = useState(false);

  const form = Form.useFormInstance();

  const handlePasswordChange = (e) => {
    const trimmedPassword = e.target?.value?.trim();
    setPassword(trimmedPassword);
    form?.setFieldsValue({ [name]: trimmedPassword });
  };

  return (
    <>
      <Form.Item
        // validateTrigger="onBlur"
        name={name}
      >
        <Input
          id='password'
          value={password}
          autoComplete={autoCompletePassword}
          type={passwordVisible ? 'text' : 'password'}
          suffix={passwordVisible ? <EyeClosed onClick={() => setPasswordVisible(false)} /> : <EyeOpen onClick={() => setPasswordVisible(true)} />}
          onChange={handlePasswordChange}
        />
      </Form.Item>
    </>
  );
};
